import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function SectionFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于吃瓜网，你可能想知道的</p>
        <div className="flex flex-col gap-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`text-lg text-foreground-400 transition-transform flex-shrink-0 ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}